import { SELECT_ALL, UNSELECT_ALL } from './CheckboxCounterContainer/constants'
import {
  ACTIVATE_SELECT_ALL,
  ATTACHMENTS_AND_LINKS_FILTER_CHANGE,
  CLUSTER_UNDO_ASYNC,
  CLUSTER_UNDO_MODAL_CLOSE,
  DATA_REQUEST_ASYNC,
  DOWNLOAD_EMAIL_ASYNC,
  END_USERS_FILTER_CHANGE,
  IPS_FILTER_CHANGE,
  IS_READ_FILTER_CHANGE,
  JUNK_MAIL_FILTER_CHANGE,
  MAILBOX_FILTER_CHANGE,
  NOT_FOUND_FILTER_CHANGE,
  PAGINATE_CHANGE,
  REPORT_ID_SET,
  REVERT_BACK_TO_ORIGIN_ASYNC,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SELECT_TOGGLE,
  SENDER_FILTER_CHANGE,
  SORT_PROPERTY_CHANGE,
  STOP_REMEDIATION_ASYNC,
  SUBJECT_FILTER_CHANGE,
  TOGGLE_RELEASE_FILTER,
} from './constants'

export default function () {
  const initialState = {
    reportId: null,
    data: {
      results: [],
    },
    loader: false,
    error: null,
    page: 1,
    search: '',
    sortProperty: '',
    senderFilter: [],
    subjectFilter: [],
    mailboxFilter: [],
    ipsFilter: [],
    junkMailFilter: [],
    attachmentsAndLinksFilter: '',
    notFoundFilter: false,
    isReadFilter: false,
    includeEmails: [],
    excludeEmails: [],
    selectAll: false,
    undoData: null,
    undoLoader: false,
    csvData: null,
    stopRemediationLoader: false,
    stopRemediationError: null,
    releaseRequestFilter: false,
    endUsersFilter: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case REPORT_ID_SET:
        return { ...state, reportId: action.payload.reportId, selectedIds: {} }
      case DATA_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          selectedIds: {},
          includeEmails: [],
          excludeEmails: [],
        }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case DATA_REQUEST_ASYNC.CANCEL:
        return { ...initialState, loader: false, page: 1 }

      case STOP_REMEDIATION_ASYNC.INITIATE:
        return {
          ...state,
          stopRemediationLoader: true,
        }
      case STOP_REMEDIATION_ASYNC.SUCCESS:
        return {
          ...state,
          stopRemediationError: null,
          stopRemediationLoader: false,
        }
      case STOP_REMEDIATION_ASYNC.ERROR:
        return {
          ...state,
          stopRemediationError: action.error,
          stopRemediationLoader: false,
        }
      case SEARCH_RESET:
        return { ...state, search: '' }
      case SEARCH_CHANGE:
        return {
          ...state,
          search: action.payload.q,
          loader: true,
          page: 1,
        }
      case PAGINATE_CHANGE:
        return {
          ...state,
          page: action.payload.page,
          loader: true,
          error: null,
        }
      case SENDER_FILTER_CHANGE:
        return {
          ...state,
          senderFilter: action.payload.arr,
          page: 1,
          loader: true,
          error: null,
        }
      case SUBJECT_FILTER_CHANGE:
        Object.keys(state.data.results).map((elem) => {
          state.data.results[elem].selected = false
        })
        return {
          ...state,
          subjectFilter: action.payload.arr,
          page: 1,
          loader: true,
          data: {
            ...state.data,
            results: {
              ...state.data.results,
            },
          },
          error: null,
          selectAll: false,
          includeEmails: [],
        }
      case MAILBOX_FILTER_CHANGE:
        return {
          ...state,
          mailboxFilter: action.payload.arr,
          page: 1,
          loader: true,
          error: null,
        }
      case IPS_FILTER_CHANGE:
        return {
          ...state,
          ipsFilter: action.payload.selectedIpsArray,
          page: 1,
          loader: true,
          error: null,
        }
      case JUNK_MAIL_FILTER_CHANGE: {
        return {
          ...state,
          junkMailFilter: action.payload.arr,
          page: 1,
          loader: true,
          error: null,
        }
      }
      case SORT_PROPERTY_CHANGE:
        return {
          ...state,
          sortProperty: action.payload.value,
          loader: true,
        }
      case TOGGLE_RELEASE_FILTER:
        return {
          ...state,
          releaseRequestFilter: !state.releaseRequestFilter,
          loader: true,
        }
      case END_USERS_FILTER_CHANGE:
        return {
          ...state,
          endUsersFilter: action.payload.val,
          loader: true,
        }
      case NOT_FOUND_FILTER_CHANGE:
        return {
          ...state,
          notFoundFilter: action.payload.val,
          page: 1,
          loader: true,
          error: null,
        }
      case ATTACHMENTS_AND_LINKS_FILTER_CHANGE:
        return {
          ...state,
          attachmentsAndLinksFilter: action.payload.val,
          page: 1,
          loader: true,
          error: null,
        }
      case IS_READ_FILTER_CHANGE:
        return {
          ...state,
          isReadFilter: action.payload.val,
          page: 1,
          loader: true,
          error: null,
        }
      case SELECT_TOGGLE: {
        const id = action.payload.id
        const currentResult = state.data.results[id]
        const updatedResult = {
          ...currentResult,
          selected: !currentResult.selected,
        }

        const updates = state.selectAll
          ? {
              excludeEmails: state.excludeEmails.includes(id)
                ? state.excludeEmails.filter((emailId) => emailId !== id)
                : [...state.excludeEmails, id],
            }
          : {
              includeEmails: state.includeEmails.includes(id)
                ? state.includeEmails.filter((emailId) => emailId !== id)
                : [...state.includeEmails, id],
              selectAll: false,
            }

        return {
          ...state,
          ...updates,
          data: {
            ...state.data,
            results: {
              ...state.data.results,
              [id]: updatedResult,
            },
          },
        }
      }
      case SELECT_ALL: {
        Object.keys(state.data.results).map((elem) => {
          if (!state.data.results[elem].firstReported) {
            state.includeEmails.push(state.data.results[elem].id)
            state.data.results[elem].selected = true
          }
        })
        return {
          ...state,
          includeEmails: state.includeEmails,
          excludeEmails: [],
          data: {
            ...state.data,
            results: {
              ...state.data.results,
            },
          },
        }
      }
      case UNSELECT_ALL: {
        Object.keys(state.data.results).map((elem) => {
          state.data.results[elem].selected = false
        })
        return {
          ...state,
          includeEmails: [],
          excludeEmails: [],
          data: {
            ...state.data,
            results: {
              ...state.data.results,
            },
          },
          selectAll: false,
        }
      }
      case ACTIVATE_SELECT_ALL:
        return {
          ...state,
          selectAll: true,
          includeEmails: [],
        }
      case REVERT_BACK_TO_ORIGIN_ASYNC.INITIATE:
      case CLUSTER_UNDO_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          undoData: null,
          undoLoader: true,
        }
      case REVERT_BACK_TO_ORIGIN_ASYNC.SUCCESS:
      case CLUSTER_UNDO_ASYNC.SUCCESS:
        return {
          ...state,
          undoLoader: false,
          includeEmails: [],
        }
      case REVERT_BACK_TO_ORIGIN_ASYNC.ERROR:
      case CLUSTER_UNDO_ASYNC.ERROR:
        Object.keys(state.data.results).map((elem) => {
          state.data.results[elem].selected = false
        })
        return {
          ...state,
          undoLoader: false,
          includeEmails: [],
          data: {
            ...state.data,
            results: {
              ...state.data.results,
            },
          },
          selectAll: false,
        }
      case REVERT_BACK_TO_ORIGIN_ASYNC.CANCEL:
      case CLUSTER_UNDO_ASYNC.CANCEL:
        return {
          ...state,
          undoLoader: false,
        }
      case CLUSTER_UNDO_MODAL_CLOSE:
        return {
          ...state,
          undoLoader: false,
          undoData: null,
        }

      // case DOWNLOAD_EMAIL_ASYNC.ERROR: {
      //   const foundMailbox = state.data.results[action.payload.id]
      //   if (foundMailbox) {
      //     foundMailbox.disabled = true
      //   }
      //   return {
      //     ...state,
      //     data: {
      //       ...state.data,
      //       results: [...state.data.results],
      //     },
      //   }
      // }
      default:
        return state
    }
  }
}
